import { EffortTagColors } from "../../constants";
import { capitalize } from "lodash";

export interface EffortTagProps {
  effort: string;
}

const EffortTag = ({ effort }: EffortTagProps) => {
  return (
    <div
      className="al-w-min al-rounded-full al-px-2 al-py-0.5 al-text-center al-text-xs al-font-medium al-leading-4 al-text-white"
      style={{
        backgroundColor: EffortTagColors[effort as keyof typeof EffortTagColors],
      }}
    >
      {capitalize(effort)}
    </div>
  );
};

export default EffortTag;
